<template>
  <div class="agenda" data-scroll-section>
    <Author  :scroll="scroll"/>
    <Broadcast :broadcaseData="broadcaseData"></Broadcast>
    <Theme :agendaDatas="agendaDatas"/>
    <Speakers :speakerData="speakerData"/>
  </div>
</template>

<script>
import Author from '@/components/agenda/Author'
import Broadcast from '@/components/agenda/Broadcast'
import Theme from '@/components/agenda/Theme'
import Speakers from '@/components/agenda/Speakers'
export default {
  data () {
    return {
      agendaDatas: [],
      broadcaseData: {},
      speakerData: []
    }
  },
  components: {
    Author,
    Broadcast,
    Theme,
    Speakers
  },
  props: {
    scroll: Object
  },
  methods: {
    async getGuestlist () {
      let $this = this
      const id = this.$route.params.zone_id
      const { data: res } = await this.$http.get(`/sessions/?zone_id=${id}`)
      const { data: res1 } = await this.$http.get(`/zones/${id}`)
      if (res.code === 1) {
        this.agendaDatas = res.data
        this.broadcaseData = res1.data
        // const hours = new Date().getHours()
        // const minute = new Date().getMinutes()
        // if (this.agendaDatas.length > 0) {
        //   this.agendaDatas.forEach((item, index) => {
        //     const itime = item.to_time.split(':')
        //     console.log(itime)
        //     if (item.video !== '') {
        //       if (itime[0] > hours) {
        //         this.broadcaseData.push(item)
        //       }
        //       if (itime[0] === hours) {
        //         if (itime[1] > minute) {
        //           this.broadcaseData.push(item)
        //         }
        //       }
        //     }
        if (this.agendaDatas.length > 0) {
          this.agendaDatas.forEach((item) => {
            item.guests.forEach((item1) => {
              this.speakerData.push(item1)
              this.removalRepeat(this.speakerData)
            })
          })
        }
        setTimeout(() => {
          $this.scroll.update()
        }, 100)
      }
    },
    removalRepeat (arr) {
      const map = new Map()
      for (const i of arr) {
        if (!map.has(i.user)) {
          map.set(i.user, i)
        }
      }
      arr = [...map.values()]
      this.speakerData = arr
    }
  },
  mounted () {
    this.getGuestlist()
  }
}
</script>

<style>

</style>